import { combineEpics } from 'redux-observable';
import { EmailAddressActionTypes, AddEmail, DeleteEmail, ResendVerification, SetPrimary } from '../actions/EmailAddressActions';
import { getAddEmailRequestStatus, getDeleteEmailRequestStatus, getResendVerificationRequestStatus, getSetPrimaryRequestStatus } from '../selectors/RequestStatusSelector';
import EmailsAPI from '../api/EmailsAPI';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import RequestEpicDescriptor from './RequestEpicDescriptor';
import requestEntity from './requestEntity';
const addEmail = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailsAPI.add,
  initiatingActionType: EmailAddressActionTypes.ADD_EMAIL,
  requestStatusSelector: getAddEmailRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: AddEmail,
  alertOnSuccess: true,
  alertOnFailure: false
}));
const deleteEmail = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailsAPI.remove,
  initiatingActionType: EmailAddressActionTypes.DELETE_EMAIL,
  requestStatusSelector: getDeleteEmailRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: DeleteEmail,
  alertOnSuccess: true,
  alertOnFailure: false
}));
const resendVerification = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailsAPI.resendVerification,
  initiatingActionType: EmailAddressActionTypes.RESEND_VERIFICATION,
  requestStatusSelector: getResendVerificationRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: ResendVerification,
  alertOnSuccess: true,
  alertOnFailure: false
}));
const setPrimary = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailsAPI.setPrimary,
  initiatingActionType: EmailAddressActionTypes.SET_PRIMARY,
  requestStatusSelector: getSetPrimaryRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: SetPrimary,
  alertOnSuccess: true,
  alertOnFailure: false
}));
export default combineEpics(addEmail, deleteEmail, resendVerification, setPrimary);